export enum AccessLevel {
  Selection = -6,
  ViewHistory = -5,
  Back = -4,
  Discard = -3,
  SaveAndNew = -2,
  Save = -1,
  None = 0,
  View = 1,
  New = 2,
  Edit = 4,
  Delete = 8,
  Print = 16,
  Export = 32,
  Send = 64,
}

export enum InputType {
  None = 0,
  Text = 1,
  Email = 2,
  Phone = 3,
  Mobile = 4,
  Number = 5,
  Date = 6,
  IsActive = 7,
  Amount = 8,
  Dropdown = 9,
  HTML = 10,
  Index = 11,
  DateTime = 12,
  SubReport = 13,
  MultiSelect =14,
  PopReport =15, /*~~~~~~~~~~~~~ Tushar 2024-12-09 Gid.:198*/
  PaymentStatus = 16 //--Gaurav :- For Local Purchase Invoice
}

export enum HireSlip {
  None = 0,
  Load = 1,
  Unload = 2,
}

export enum DocumentType {
  None = 0,
  CPOSUser = 1,
  ZotaStoreDoc = 2,
  StoreNearBy = 8,
  StorePic = 21,
  ColorPic = 26,
  FurniturePic = 28,
  BrandingPest = 30,
  StockPaymentDetail = 41,
  AccountStockPaymentDetail = 42,
}

// ActionField = 9

export enum ShortCutKeys {
  None = -1,
  Alt0 = 0,
  Alt1 = 1,
  Alt2 = 2,
  Alt3 = 3,
  Alt4 = 4,
  Alt5 = 5,
  Alt6 = 6,
  Alt7 = 7,
  Alt8 = 8,
  Alt9 = 9,
  AltS = 10,
  AltF = 11,
  AltC = 12,
  PageUp = 13,
  PageDown = 14,
  Home = 15,
  End = 16,
  Delete = 17,
  AltA = 18,
  AltR = 19,
  AltX = 20,
  Enter = 21,
}

export enum KEY_CODE {
  ENTER = 13,
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  PAGE_UP = 33,
  PAGE_DOWN = 34,
  END = 35,
  HOME = 36,
  DELETE = 46,
}

export enum CPOSEnum {
  None = 0,
  User = 1,
  UserRegistration = 2,
  UserRights = 3,
  StoreList = 4,
  LiveStoreList = 5,
  StoreInfo = 6,
  StorePo = 7,
  POSSale = 22,
  SAPSale = 23,
  SalesMISReport = 10,
  StorePoDetail = 11,
  PaymentOustanding = 12,
  WarehouseStock = 13,
  StoreStock = 14,
  Report_Day_wise_average_Sale = 37,
  Report_State_wise_Report = 38,
  Report_GSTR1 = 39,
  Report_GSTR2 = 40,
  Report_Sales_Report = 41,
  Report_Distributor_Dispatch = 45,
  Report_Fast_Moving_Item = 46,
  Report_Slow_Moving_Item = 47,
  Report_Store_Purchase_Details = 49,
  Report_Saving = 50,
  Report_Demand_Vs_Supply = 55,
  Report_BookingList = 53,
  Rivigo_Create_Booking = 54,
  Scheme_Master = 59,
  Product_Master = 60,
  Salt_Master = 61,
  Other_Brand = 62,
  Welcome_Kit = 63,
  Document_Library = 64,
  Chat_Support = 92,
  Document_Process = 89,
  StoreExecution_Process = 90,
  Employee = 91,
  CatagotyMapping = 93,
  StoreCatagoryPoints = 94,
  adjustPoints = 95,
  storevendormapping = 97,
  schemeTransaction = 99,
  notificationList = 102,
  tabsequence = 103,
  Return_Policy = 106,
  Batch_Recall = 107,
  CashBook = 121,
  BillScheme = 111,
  schemeDetails = 123,
  storenotificationlist = 124,
  notificationremarklist = 125,
  storeexecutiontracker = 126,
  updateinactivestore = 127,
  schemereport = 128,
  Report_Request = 130,
  Notification_Master = 131,
  gstReport = 132,
  gstSalesInvoiceReport = 133,
  gstSalesReturnReport = 134,
  gstPurchaseInvoiceReport = 135,
  gstPurchaseReturnReport = 136,
  TermsAndConditions_Master = 138,
  // #433 Nidhi 14-09-2023 GST HSN Report
  gstHSNReport = 139,
  // #434 Nidhi 14-09-2023 GST Docs Report
  gstDocsReport = 140,
  batchwisesalesreport = 141,
  batchWiseSalesTertiaryReport = 142,
  Document_Process_ReApproval = 143,
  //~~~~~~~~~~ Pankaj 07-12-2023 GID: 542
  Product_Movemet_Dump_Data = 145,
  //~~~~~~~~~~ Pankaj 08-12-2023 GID: 546
  productwisesalessecondaryreport = 146,
  productwisesalestertiaryreport = 147,
  productwisesalesprimaryreport = 148,
  //~~~~~~~~~~ Tushar 05-12-2023 GID: 535
  batchWiseSalesSecondaryReport = 149,
  StoreExecutionProcessHistroy = 153,
  OrderStockAssessmentReport = 154,
  //~~~~~~~~~~ karan 28-03-2024 GID: 6
  VendorMaster = 157,
  //~~~~~~~~~~ //nibha 02-07-2024 gid #22
  LocationTemplateMaster = 158,
  //~~~~~~~~~~ //nibha 16-07-2024 gid #38
  Fix_Discount = 160,
  ProductMRPRequest = 161, //MR_45_46_Add_Report_Product_MRP,
  TemplateLocationMaster = 163, //MR_,5_TemplateLocation_Master
  Product_MRP_Change = 164, //nibha 01-08-2024 gid #33

  StoreTemplateMapping = 165, //MR_25_TemplateLocation_Master
  Product_Location_Matrix = 166, //MR_48_Product_Location_Matrix
  Reward_Point = 167, //~~~~~~~~~~~~~~~~ Nibha 23-10-24 GID #78
  Reward_Point_Scheme = 171, //~~~~~~~~~~~~~~ Nibha 13-12-2024 GID #120
  Petty_Cash_Master = 172, //~~~~~~~~~~~~~~ Nibha 13-12-2024 GID #120
  Reward_Point_Redeem = 168, //~~~~~~~~~~~~~~~~ Nibha 14-11-24 GID #103
  Product_Flag_Configuration = 173, //~~~~~~~~~ Nibha  12-03-25 GID #155
  Expense_And_Income_Category = 176, //~~~~~~~~~ Nibha  26-03-25 GID #158
  Local_Purchase_Invoice = 179, //-- Gaurav 26-03-25 GID #250
  Customer_Report = 75, // --Gaurav --13-06-2025 GID #208 
  Product_Mapping_With_Store = 181, //~~~~~~~~~~ Nibha 06-05-2025 GID #163
  Exclude_Product_Template = 184, //~~~~~~~~~~ Nibha 13-06-2025 GID #214
  CouponCodeMaster = 187,  //~~~~~~~~~~ Gaurav 30-06-2025  Added for managing Coupon Code Master functionality (e.g., create, update)
  SyncSummaryDashboard = 188 , // ~~~~~~~~~~ Gaurav 15-07-2025  For see sync summary dashboard
  ProductMapWithLocalVen = 189, // ~~~~~~~~~~~~GID:323 Karan 28-07-2025 
  ChangeSalesPrice = 191, // ~~~~~~~~~~~~GID:336 Gaurav 28-07-2025 For change sales Rate of product
  MonthlyIncentiveReport = 196, //-- GID:355 Karan 30092025
  StockAudit  = 199, //-- GID:421 Karan 07112025
  StockAdjustmentRequest  = 200, //-- GID:476 Karan 22122025
  StockTransferRequest  = 201, //-- GID:476 Karan 22122025
  SalesInvoiceBankPayment = 203,  //-- GID:488 Karan 26122025
  SalesReturnRequest = 205,  //-- GID:488 Karan 26122025
  StoreValuation = 185,  //-- GID:Direct Form Vishal Sir Karan 10022026
  ConsolidatedClosingReportComponent = 208,  //-- GID:521 Karan 16022026
  LoyaltyConfiguration =209,  //-- RID:680 Karan 19022026
  AdvertisementConfiguration = 211,  //-- RID:672 Karan 05032026
  ApplicationConfigUi = 214, //-- RID:5508 Karan 24032026
  BasketScheme = 216, //-- RID:5508 Karan 24032026
  LocationWiseSPChangeRequestStatus, //-- RID:19496 Karan 21052026
  BulkSelling = 222, //-- RID:22658 Karan 12062026
  FestivalMaster = 226, //-- RID:25396 Karan 26062026
  YearlyFestival = 231, //-- RID:31664 Karan 21072026
  FestivalForecasting = 232, //-- RID:25399 Karan 29072026
  StoreEodApproval = 236, //-- RID:38859 Dhruv 13082026
  StoreDirectPI = 238, //-- RID:38848 Karan 18082026
  StockAging = 240, //-- RID:37945 Karan 19082026
  StoreMonthlyTarget = 246, //-- RID:22352 Karan 
  ChangeProductLocationRequest = 247,
  EODClosing = 248,
  LocationWiseSPChangeRequestReport = 250,
  WHStoreProductMapping = 251,
  ProductWiseSales = 256,
  StockAdjustmentRequestReport = 257
}

export enum ConfirmationHeader {
  Confirmation,
  Warning,
  Notification,
  Success,
  Error,
}

export enum POStatus {
  UnApprove = 0,
  Approved = 1,
  Rejected = 2,
  Dispatch = 3,
  Hold = 4,
}

export enum StoreExeDocType {
  ShopPictures = 1,
  ColorPictures = 2,
  FurniturePictures = 3,
  BrnadingPictures = 4,
  Aadharfront = 5,
  AadharBack = 6,
  PanNoFront = 7,
  PanNoBack = 8,
  GstNoFront = 9,
  GstNoBack = 10,
  VideoName = 11,
  _20_20B = 12,
  _21_21B = 13,
  _21c = 14,
  StoreNearbyImages = 15,
  InvitationCard = 16,
  RentAgreement = 17,
  DocumentofProperty = 18,
  Selfie = 19,
  Digitalsign = 20,
  PloicydigSign = 21,
  paymentdetails = 22,
  _20f = 23,
  StockPaymentDetail = 24,
  // added by ashish
  StoreLocationImages = 25,
  AccountStockPaymentDetails = 42,
  DLChallanReceipt = 43,
}
///Always Sync Eith Table StoreExecutionRightsMaster
export enum StoreExecutionRights {
  FirmDetails = 1,
  StoreDetails = 2,
  PrivacyPolicy = 3,
  DlDetails = 4,
  StoreAgreement = 5,
  PaymentDetails = 6,
  InfrastructureDetails = 7,
  BrandingDetails = 8,
  FinalisationDetails = 9,
  OpeningDetails = 10,
  // PersionDetails = 11,
  // AccountDetails = 12,
  // DispatchDetails = 13
  AccountDetails = 11,
  DispatchDetails = 12,
  FollowUpRemarks = 13,
}

///use for assign role tab Table StoreExecutionRightsMaster
export enum DocumentTabRoleRights {
  PersionDetails = 1,
  FirmDetails = 2,
  StoreDetails = 0,
  PrivacyPolicy = 3,
  Secondarydetails = 4,
  DlDetails = 4,
  StoreAgreement = 5,
  PaymentDetails = 6,
}
export enum StoreExecutiomTabRoleRights {
  InfrastructureDetails = 0,
  BrandingDetails = 1,
  FinalisationDetails = 2,
  OpeningDetails = 5,
  AccountDetails = 3,
  DispatchDetails = 4,
  FollowUpRemarks = 6,
}

///manage In API Also
export enum StoreReturnType {
  InitialReturn = 1,
  FirstTimeMonthReturn = 2,
  Every6MonthReturn = 3,
  SpecificReturn = 4,
}
